import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['banner'];

  connect() {
    this.hideBanner();
  }

  hideBanner() {
    if (this.bannerTargets.length) {
      setTimeout(() => {
        this.bannerTargets.forEach((target) => this.fadeOut(target));
      }, 5000);
    }
  }

  fadeOut(el) {
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = 'none';
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }
}
